/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import Wrapper from "./GlobalComponents/Wrapper";
import Row from "./GlobalComponents/Row";
import Title from "./GlobalComponents/Title";
import SubTitle from "./GlobalComponents/SubTitle";
import Slider from "./GlobalComponents/Slider";

const PositioningSettings = () => {
  const {
    panelHeight,
    setPanelHeight,
    textHorizontal,
    setTextHorizontal,
    textVertical,
    setTextVertical,
    iconHorizontal,
    setIconHorizontal,
    iconVertical,
    setIconVertical,
  } = useContext(PanelsContext);
  return (
    <div css={styles} className="positioningSettings">
      <Row>
        <Title title="General" />
      </Row>
      <Row>
        <SubTitle text="Panel Height" />
        <Wrapper>
          <Slider
            inputType="range"
            minVal="60"
            maxVal="80"
            defVal={panelHeight}
            setVal={setPanelHeight}
          />
          <p>{panelHeight}px</p>
        </Wrapper>
      </Row>
      <Row>
        <Title title="Text" />
      </Row>
      <div className="rowContainer">
        <Row>
          <SubTitle text="Horizontal Position" />
          <Wrapper>
            <Slider
              inputType="range"
              minVal="0"
              maxVal="185"
              defVal={textHorizontal}
              setVal={setTextHorizontal}
            />
            <p>{textHorizontal}px</p>
          </Wrapper>
        </Row>
        <Row>
          <SubTitle text="Vertical Position" />
          <Wrapper>
            <Slider
              inputType="range"
              minVal="18"
              maxVal="150"
              defVal={textVertical}
              setVal={setTextVertical}
            />
            <p>{textVertical}px</p>
          </Wrapper>
        </Row>
      </div>
      <Row>
        <Title title="Icon" />
      </Row>
      <div className="rowContainer">
        <Row>
          <SubTitle text="Horizontal Position Offset" />
          <Wrapper>
            <Slider
              inputType="range"
              minVal="20"
              maxVal="140"
              defVal={iconHorizontal}
              setVal={setIconHorizontal}
            />
            <p>{iconHorizontal}px</p>
          </Wrapper>
        </Row>
        <Row>
          <SubTitle text="Vertical Position Offset" />
          <Wrapper>
            <Slider
              inputType="range"
              minVal="20"
              maxVal="140"
              defVal={iconVertical}
              setVal={setIconVertical}
            />
            <p>{iconVertical}px</p>
          </Wrapper>
        </Row>
      </div>
    </div>
  );
};

const styles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  .rowContainer {
    display: flex;
    justify-content: space-between;
  }
  .row {
    .wrapper {
      input {
        width: 70%;
        padding: 0;
      }
      p {
        color: #fff;
        font-size: 15px;
      }
    }
  }
`;

export default PositioningSettings;
